import { Link } from "react-router-dom";

import { Logo } from "~/icons";
import { ROUTES } from "~/router";
import { Button } from "~/shared";
import { useNavigationStore } from "~/stores";
import { icons } from "~/ui";
import { ProfileDropdown } from "./ProfileDropdown";

export const Header = () => {
  const { openSidebar } = useNavigationStore();

  return (
    <div
      className="border-blueGrey h-18 shadow-xs fixed z-40 flex w-full shrink-0 items-center justify-between gap-x-4 border-b bg-white px-6 sm:gap-x-6 lg:h-20 lg:justify-end lg:px-8"
      style={{ top: "var(--hub-banner-height, 0px)" }}
    >
      <button
        type="button"
        onClick={openSidebar}
        className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
      >
        <span className="sr-only">Open sidebar</span>
        <icons.outline.Bars3Icon
          aria-hidden="true"
          className="text-violet80 size-6"
        />
      </button>

      <div className="flex flex-1 items-center justify-end gap-4 self-stretch">
        <Button asChild className="hidden px-6 py-2 md:block">
          <Link to={ROUTES.hubBookVisit}>Book a visit</Link>
        </Button>

        <ProfileDropdown className="hidden lg:block" />

        <div className="lg:hidden">
          <Logo className="block h-9" />
        </div>
      </div>
    </div>
  );
};
